export default __webpack_public_path__ + "static/media/img2-2.435e83a2.jpg";